<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="user.firstname + ' ' + user.lastname"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="clickOnValidateBtn">

              <div v-if="isEstateAgent" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.personal.infos') }}
                </span>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group
                        :invalid-feedback="form.firstname.invalidFeedback"
                        :label="$t('user.Firstname')"
                        :state="form.firstname.state"
                        class="medium-label mb-4"
                        label-for="firstname-input">
                        <b-form-input
                          id="firstname-input"
                          v-model="form.firstname.value"
                          :state="form.firstname.state"
                          maxlength="250"
                          placeholder="Prénom"
                          required
                          type="text">
                        </b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-12">
                      <b-form-group
                        :invalid-feedback="form.username.invalidFeedback"
                        :label="$t('user.Username')"
                        :state="form.username.state"
                        class="medium-label mb-4"
                        label-for="username-input">
                        <b-form-input
                          id="username-input"
                          v-model="form.username.value"
                          :state="form.username.state"
                          placeholder="email@email.com"
                          required
                          type="email">
                        </b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group
                        :invalid-feedback="form.lastname.invalidFeedback"
                        :label="$t('user.Lastname')"
                        :state="form.lastname.state"
                        class="medium-label mb-4"
                        label-for="lastname-input">
                        <b-form-input
                          id="lastname-input"
                          v-model="form.lastname.value"
                          :state="form.lastname.state"
                          maxlength="250"
                          placeholder="Nom"
                          required
                          type="text">
                        </b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-12">
                      <b-form-group
                        :invalid-feedback="form.phoneNumber.invalidFeedback"
                        :label="$t('user.PhoneNumber')"
                        :state="form.phoneNumber.state"
                        class="medium-label mb-4"
                        label-for="phoneNumber-input">
                        <b-form-input
                          id="phoneNumber-input"
                          v-model="form.phoneNumber.value"
                          :state="form.phoneNumber.state"
                          maxlength="250"
                          placeholder="0123456789"
                          required
                          type="text">
                        </b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <div v-if="isEstateAgent" class="col-md-4">
                  <b-form-group
                    class="medium-label mb-4">
                    <div class="d-flex">
                      <label for="picture-input">
                        {{ $t('user.Picture') }}
                      </label>
                      <span class="ml-1">{{ $t('facultative.for.label') }}</span>
                    </div>
                    <custom-form-file
                      id="picture-input"
                      v-model="form.picture.value"
                      :drop-placeholder="$t('drop-placeholder')"
                      :placeholder="form.picture.value"
                      :state="form.picture.state"
                      accept=".png, .jpeg, .jpg"
                      @preview="imagePreview = $event"
                      @input="askConfirm=true"
                    />
                    <div>
                      <img v-if="imagePreview" :src="imagePreview" alt="Image preview" class=" mt-1 sidebar-header-logo-user bordered" :class="{ 'reframe':form.reframe.value }"/>
                      <img v-else-if="!imagePreview&&this.user.picture"
                           :src="getFileUrl(this.user.picture.fileUrl)" alt="Image preview"
                           class=" mt-1 sidebar-header-logo-user bordered" :class="{ 'reframe':form.reframe.value }"/>
                    </div>
                    <div>
                      <b-form-checkbox
                        v-model="form.reframe.value"
                      >
                        Recadrer l'image
                      </b-form-checkbox>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div v-if="isEstateAgent" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.entreprise.infos') }}
                </span>
              </div>

              <div v-if="isEstateAgent" class="row">
                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.entreprise.invalidFeedback"
                    :label="$t('user.Entreprise')"
                    :state="form.entreprise.state"
                    class="medium-label mb-4"
                    label-for="entreprise-input">
                    <b-form-input
                      id="entreprise-input"
                      v-model="form.entreprise.value"
                      :state="form.entreprise.state"
                      maxlength="250"
                      placeholder="Entreprise"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-3">
                  <b-form-group
                    :invalid-feedback="form.address.invalidFeedback"
                    :label="$t('user.Address')"
                    :state="form.address.state"
                    class="medium-label mb-4"
                    label-for="address-input">
                    <b-form-input
                      id="address-input"
                      v-model="form.address.value"
                      :state="form.address.state"
                      maxlength="250"
                      placeholder="Rue de la paix"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-2">
                  <b-form-group
                    :invalid-feedback="form.postalCode.invalidFeedback"
                    :label="$t('user.PostalCode')"
                    :state="form.postalCode.state"
                    class="medium-label mb-4"
                    label-for="postalCode-input">
                    <b-form-input
                      id="postalCode-input"
                      v-model="form.postalCode.value"
                      :state="form.postalCode.state"
                      placeholder="75000"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-3">
                  <b-form-group
                    :invalid-feedback="form.city.invalidFeedback"
                    :label="$t('user.City')"
                    :state="form.city.state"
                    class="medium-label mb-4"
                    label-for="city-input">
                    <b-form-input
                      id="city-input"
                      v-model="form.city.value"
                      :state="form.city.state"
                      maxlength="250"
                      placeholder="Paris"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-3">
                  <b-form-group
                    :invalid-feedback="form.capitalSocial.invalidFeedback"
                    :label="$t('user.CapitalSocial')"
                    :state="form.capitalSocial.state"
                    class="medium-label mb-4"
                    label-for="capital-input">
                    <b-input-group>
                      <b-form-input
                        id="capital-input"
                        v-model="form.capitalSocial.value"
                        :state="form.capitalSocial.state"
                        maxlength="250"
                        placeholder="10000€"
                        type="text">
                      </b-form-input>
                      <b-input-group-append>€</b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>

                <div class="col-md-3">
                  <b-form-group
                    :invalid-feedback="form.siret.invalidFeedback"
                    :label="$t('user.Siret')"
                    :state="form.siret.state"
                    class="medium-label mb-4"
                    label-for="siret-input">
                    <b-form-input
                      id="siret-input"
                      v-model="form.siret.value"
                      :state="form.siret.state"
                      maxlength="14"
                      minlength="14"
                      placeholder="12345678912345"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-3">
                  <b-form-group
                    :invalid-feedback="form.rcs.invalidFeedback"
                    :label="$t('user.Rcs')"
                    :state="form.rcs.state"
                    class="medium-label mb-4"
                    label-for="rcs-input">
                    <b-form-input
                      id="rcs-input"
                      v-model="form.rcs.value"
                      :placeholder="$t('user.Rcs.placeholder')"
                      :state="form.rcs.state"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-3" v-if="isEstateAgent">
                  <b-form-group
                    :label="$t('society.date.exercice.comptable')"
                    :label-for="`date-society`"
                    :invalid-feedback="form.dateComptable.invalidFeedback"
                    :state="form.dateComptable.state"
                    class="medium-label mb-4">
                    <datepicker-input
                      :id="`date-society`"
                      v-model="form.dateComptable.value"
                      :state="form.dateComptable.state"
                      v-on:input="removeInvalidFeedback('dateComptable')"
                      v-on:change="removeInvalidFeedback('dateComptable')">
                    </datepicker-input>
                  </b-form-group>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from '../../services/api'
import i18n from '../../i18n'
import backArrow from "../../components/b122/BackArrow";
import {bus} from "../../main";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";

export default {

  name: 'Profile',

  components: {
    backArrow,
    DatepickerInput,
    CustomFormFile
  },

  data() {
    return {
      userId: this.$store.getters.userId,
      isEstateAgent: this.$store.getters.isEstateAgent,
      imagePreview: null,
      isFreeAccount: null,
      askConfirm: false,
      user: {},
      form: {
        firstname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        entreprise:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        capitalSocial:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        rcs:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        siret:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        picture:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        dateComptable:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        reframe:
          {
            value: null
          }
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    previewImage(event) {

      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };

      reader.readAsDataURL(file);
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    async fetchData() {
      this.fetchUser()
    },

    fetchUser() {
      api
        .get(`/user/getProfile`)
        .then(response => {
          this.user = response.data
          this.setInitialValues()
        })
        .catch((error) => {
          this.$router.push({
            name: '/',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    setInitialValues() {
      this.form.firstname.value = this.user.firstname
      this.form.lastname.value = this.user.lastname
      this.form.username.value = this.user.username
      this.form.phoneNumber.value = this.user.phoneNumber
      this.form.entreprise.value = this.user.entreprise
      this.form.address.value = this.user.address
      this.form.postalCode.value = this.user.postalCode
      this.form.city.value = this.user.city
      this.form.capitalSocial.value = this.user.capitalSocial
      this.form.siret.value = this.user.siret
      this.form.rcs.value = this.user.rcs
      if (this.user.picture) {
        this.form.picture.value = this.user.picture.filename
        this.form.reframe.value = this.user.picture.reframe
      }
      if(this.isEstateAgent){
        this.form.dateComptable.value = this.user.dateComptable ? new Date(this.user.dateComptable).toLocaleDateString().split("/").reverse().join("-") : null
      }
    },

    clickOnValidateBtn() {
      this.onSubmit()
    },

    onSubmit() {
      let data = new FormData()
      data.append('firstname', this.form.firstname.value)
      data.append('lastname', this.form.lastname.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.value)
      data.append('entreprise', this.form.entreprise.value)
      data.append('address', this.form.address.value)
      data.append('postalCode', this.form.postalCode.value)
      data.append('city', this.form.city.value)
      data.append('capitalSocial', this.form.capitalSocial.value)
      data.append('siret', this.form.siret.value)
      data.append('rcs', this.form.rcs.value)
      data.append('picture', this.form.picture.value)
      data.append('reframe', this.form.reframe.value)
      if(this.isEstateAgent){
        data.append('dateComptable', this.form.dateComptable.value)
      }

      api({
        method: 'POST',
        url: `/user/updateProfile`,
        data: data
      })
        .then((response) => {
          this.user = response.data
          bus.$emit("editProfile")
          this.$store.commit('updateEntreprise', response.data.entreprise)
          this.$router.push({
            name: 'ProfileShow'
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: '/',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    successToast(userName) {
      this.$bvToast.toast(this.$i18n.t('User') + ' "' + userName + '" ' + this.$i18n.t('modified'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },
  }
}
</script>

<style scoped>
input::placeholder {
  opacity: 0.25;
  color: var(--main-text-color);
}
</style>



// WEBPACK FOOTER //
// src/views/user/ProfileEdit.vue